module.exports = __webpack_public_path__ + "static/banner_vote_tablet-e55249ee22f881a0c64f57930c6e6c03.png";